var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddProdct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_51",
    x: 0,
    y: 0,
    width: 105,
    height: 105,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3122",
    "data-name": "Rectangle 3122",
    width: 26.997,
    height: 26.979,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9344",
    "data-name": "Group 9344",
    transform: "translate(9.242 6.098)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9.24, -6.1)",
    filter: "url(#Ellipse_51)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51-2",
    "data-name": "Ellipse 51",
    cx: 43.5,
    cy: 43.5,
    r: 43.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11225",
    "data-name": "Group 11225",
    transform: "translate(26.362 26.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9240",
    "data-name": "Group 9240",
    transform: "translate(0 7.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9214",
    "data-name": "Group 9214",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M13.558,15.4a2.79,2.79,0,0,1-.451-.148c-.9-.471-1.789-.952-2.683-1.428S8.65,12.88,7.766,12.405c-.858-.46-1.713-.926-2.568-1.389s-1.72-.933-2.581-1.4c-.415-.224-.835-.439-1.25-.664-.243-.131-.481-.27-.72-.408a1,1,0,0,1-.538-.67.878.878,0,0,1,.269-.863A1.289,1.289,0,0,1,.622,6.84c.37-.212.74-.424,1.114-.629.515-.282,1.033-.557,1.55-.835l1.563-.842,1.59-.856,1.537-.827,1.6-.864q.788-.425,1.577-.848Q11.832.776,12.51.417q.306-.161.615-.315a.993.993,0,0,1,.965.051c.516.281,1.033.558,1.55.836L18.4,2.472l4.348,2.341L26.26,6.7c.115.062.229.126.338.2a.985.985,0,0,1,.449.733.871.871,0,0,1-.172.565,1.026,1.026,0,0,1-.381.358q-.772.423-1.548.841l-4.069,2.193-3.752,2.02-2.811,1.512a1.958,1.958,0,0,1-.758.274M24.11,7.678c-.06-.037-.088-.057-.118-.073l-1.238-.654c-.749-.4-1.5-.792-2.246-1.194-.818-.44-1.631-.888-2.448-1.328-.857-.462-1.716-.919-2.574-1.379-.588-.315-1.177-.63-1.763-.948a.3.3,0,0,0-.336.009c-.2.119-.4.222-.608.331q-1.855,1-3.709,2-1.451.782-2.9,1.56C5.159,6.541,4.149,7.069,3.142,7.6c-.037.019-.069.047-.127.086.087.054.148.1.212.13L7.973,10.37l4.111,2.21c.42.226.842.448,1.261.675a.383.383,0,0,0,.4,0c.336-.181.679-.346,1.016-.524.51-.27,1.017-.545,1.524-.819l1.616-.871,1.51-.813,1.643-.884c.486-.262.97-.526,1.456-.787s.957-.509,1.435-.765c.051-.027.1-.064.167-.111",
    transform: "translate(-0.079 0)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M13.5,236.227a1.043,1.043,0,0,1-.5-.152L11.74,235.4l-3.154-1.7-3.115-1.676-3.141-1.692L.57,229.381a.959.959,0,1,1,.9-1.694q.9.476,1.792.959l5.13,2.76q2.008,1.08,4.016,2.162.47.254.934.519a.267.267,0,0,0,.292.006q1.959-1.061,3.922-2.114l5.273-2.843c.852-.46,1.7-.921,2.559-1.375a2.7,2.7,0,0,1,.459-.182.947.947,0,0,1,1.082.506.935.935,0,0,1-.315,1.178c-.324.217-.669.406-1.012.593q-2.1,1.142-4.212,2.275c-.923.5-1.85.989-2.773,1.486q-1.749.942-3.5,1.889c-.362.2-.727.386-1.091.577a1.15,1.15,0,0,1-.532.146",
    transform: "translate(-0.021 -209.248)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M26.953,156.77a.867.867,0,0,1-.468.717c-.386.223-.779.437-1.171.65q-1.959,1.061-3.92,2.118c-.932.5-1.867,1-2.8,1.5q-1.749.943-3.5,1.889c-.366.2-.735.391-1.1.584a1.01,1.01,0,0,1-1.019-.012c-.809-.443-1.625-.872-2.437-1.31q-1.763-.949-3.524-1.9-1.57-.846-3.141-1.691c-.831-.446-1.664-.889-2.495-1.336-.287-.154-.57-.316-.856-.474a.99.99,0,0,1-.508-1.026.978.978,0,0,1,1.3-.713,1.627,1.627,0,0,1,.19.09l3.528,1.894,3.327,1.791q1.855,1,3.71,2,.629.34,1.253.688a.269.269,0,0,0,.292,0q2.755-1.487,5.514-2.968,2.081-1.121,4.159-2.246,1.079-.583,2.161-1.162a1.058,1.058,0,0,1,.738-.138.988.988,0,0,1,.768,1.053",
    transform: "translate(0 -143.178)",
    fill: "#393939"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M223.476,221.05h.244c1.037,0,2.074,0,3.111,0a2.4,2.4,0,0,1,.517.062,1.2,1.2,0,0,1,.926,1.15,1.221,1.221,0,0,1-1.019,1.115,3.452,3.452,0,0,1-.5.038c-1.006,0-2.012,0-3.017,0h-.259v.224c0,1.075,0,2.149,0,3.224a1.276,1.276,0,0,1-.515,1.109,1.155,1.155,0,0,1-1.815-.809,6.109,6.109,0,0,1-.037-.652c0-.95,0-1.9,0-2.849v-.246h-.237c-1.037,0-2.074,0-3.111,0a2.465,2.465,0,0,1-.536-.065,1.152,1.152,0,0,1,.131-2.265,5.4,5.4,0,0,1,.6-.036c.968,0,1.937,0,2.905,0h.251v-.232c0-1.081,0-2.162,0-3.243a1.26,1.26,0,0,1,.4-.992,1.1,1.1,0,0,1,1.184-.226,1.064,1.064,0,0,1,.738.951c.039.565.035,1.134.04,1.7.006.668,0,1.336,0,2.039",
    transform: "translate(-195.307 -216.276)",
    fill: "#0094d1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddProdct);
export default __webpack_public_path__ + "static/media/add-prodct.3a3664585ce39356eaafb137cb2774c5.svg";
export { ForwardRef as ReactComponent };